import { PresentationFieldProps, SelectField } from "@homebound/beam";
import { ReactNode } from "react";
import {
  CostCodeSelect_CostCodeFragment,
  useCostCodeSelectLazyQuery,
} from "src/components/autoPopulateSelects/CostCodeSelectField.generated";
import { emptyCellDash } from "src/components/gridTableCells";
import { CostCodeFilter, Maybe } from "src/generated/graphqlTypes";
export type CostCodeSelectFieldProps = PresentationFieldProps & {
  label?: string;
  value: Maybe<CostCodeSelect_CostCodeFragment>;
  filter?: CostCodeFilter;
  readOnly?: boolean | ReactNode;
  onSelect: (id: string | undefined, selectedCostCode: CostCodeSelect_CostCodeFragment | undefined) => void;
};

export function CostCodeSelectField(props: CostCodeSelectFieldProps) {
  const { filter, value, onSelect, readOnly, label, ...others } = props;
  const [load, { data }] = useCostCodeSelectLazyQuery({
    variables: { filter: filter ?? {} },
    fetchPolicy: "cache-first",
  });
  return (
    <SelectField
      {...others}
      label={label ?? "Cost Code"}
      readOnly={readOnly}
      unsetLabel={emptyCellDash}
      getOptionValue={(o) => o.id}
      getOptionLabel={(o) => o.displayName}
      onSelect={onSelect}
      options={{ current: value ?? undefined, load, options: data?.costCodes }}
      value={value?.id}
    />
  );
}
